import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';

import Grid from '@mui/material/Grid';
import Layout from '../components/Layout';
import List from '@mui/material/List';
import LocationTile from '../components/LocationTile';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { useAppState } from '../../index.js';

function determineActiveMeal(upcomingMeals) {
  let status = 'closed';
  let statusText = 'Closed Now';
  let time = '';
  let meal = 'Not Serving';
  let day = '';
  let hours = "h:mm a";
  let isMealSet = false;

  upcomingMeals.forEach(function (x, i) {
    // Timezone-aware moments for comparisons
    const startTime = moment(x.startTime);
    const endTime = moment(x.endTime);

    // Preserve original timezone for display
    const displayStartTime = moment.parseZone(x.startTime);
    const displayEndTime = moment.parseZone(x.endTime);

    if (moment().isBetween(startTime, endTime, null, '[]') && !isMealSet) {
      isMealSet = true;
      status = 'open';
      statusText = 'Open Now';
      time = ' until ' + displayEndTime.format(hours);
      meal = 'Serving ' + x.name;
      day = '';
    }
    else if (!isMealSet && moment().isBefore(startTime) && moment().isSame(startTime, 'day')) {
      isMealSet = true;
      status = 'closed';
      statusText = 'Closed Now';
      time = ' at ' + displayStartTime.format(hours);
      meal = 'Will open for ' + x.name;
      day = '';
    }
    else if (!isMealSet && moment().isBefore(startTime)) {
      isMealSet = true;
      status = 'closed';
      statusText = 'Closed Now';
      time = ' at ' + displayStartTime.format(hours);
      meal = 'Will open for ' + x.name;
      day = ' tomorrow';
    }
  });

  let activeMeal = {
    status: status,
    statusText: statusText,
    time: time,
    meal: meal,
    day: day
  }

  return activeMeal;
}

const InnerContent = (props) => {
  const { AppContext, locations, listOrder } = props;
  const { styleprops } = useContext(AppContext);
  return <Grid container className={"menus__home-content--container"} style={styleprops}>
    <Grid item xs={12}>
      <Grid container justify="center" spacing={5} justifyContent="center" alignItems="flex-start">
        {
          listOrder.map((x, i) => {
            const category = locations.filter(y => {
              return y.name === x
            });
            return <Grid item style={{ minWidth: 300 }} key={i}>
              <nav aria-labelledby={`${category[0].name}-heading`}>
                <Paper elevation={8} component="section">
                  <Typography
                    aria-label={`${category[0].name} heading`}
                    id={`${category[0].name}-heading`}
                    component="h2"
                    variant="h6"
                    style={{ textAlign: 'center', paddingTop: 15 }}
                  >
                    <span>{category[0].name}</span>
                  </Typography>
                  <List role="list" aria-label={`${category[0].name} dining locations`}>{category[0].diningCourts.map((x, index) => {
                    return <LocationTile determineActiveMeal={determineActiveMeal} {...x} key={x.formalName} listItemIndex={index + 1} listItemTotal={category[0].diningCourts.length} />
                  })}</List>
                </Paper>
              </nav>
            </Grid>
          })
        }
      </Grid>
    </Grid>
  </Grid>
}

const DisplayLocations = (props) => {
  const { locations, currentUser, GET_USER } = useAppState();
  const { AppContext } = props;
  const listOrder = ["Dining Courts", "Quick Bites", "On-the-GO!"];
  return (
    <>
      <Helmet>
        <title>Purdue Dining Menus - Home</title>
        <meta name="description" content="Browse Purdue University dining court menus, hours, and locations. Find dining courts, quick bites, and on-the-go options across campus." />
        <meta name="keywords" content="Purdue dining, campus dining, dining courts, meal plans, university food" />
        <meta property="og:title" content="Purdue Dining Menus" />
        <meta property="og:description" content="Browse Purdue University dining court menus, hours, and locations." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Layout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Home">
        <InnerContent AppContext={AppContext} locations={locations} listOrder={listOrder} />
      </Layout>
    </>
  );
}

// Documentation note:
// AppContext is used to create a context object that can contain props that are passed down to child components. 
// This method is being used to replace the React.cloneElement()
// AppContext is defined in index.js > passing it along as props to both the layout and InnerContent > 
// Context values are then set in Layout > then on InnerContent I'm using the useContext hook to get the values.

export default DisplayLocations;